import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SkyChevronComponent } from './chevron.component';
import { SkyResourcesModule } from '../resources';


export class SkyChevronModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [SkyChevronComponent],
  imports: [CommonModule, SkyResourcesModule],
  exports: [SkyChevronComponent]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
